import { Component, ViewChild } from "@angular/core";
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from "ag-grid-community";
import { SearchPageService } from "../../../search-page.service";
import { MatTooltip } from "@angular/material/tooltip";
import { TranslateService } from "@ngx-translate/core";
import { NotificationService } from "../../../../services/notification.service";

@Component({
    selector: 'se-associated-specialty-renderer',
    templateUrl: './associated-specialty-renderer.component.html',
    styleUrls: ['./associated-specialty-renderer.component.scss'],
    standalone: false
})
export class AssociatedSpecialtyRendererComponent implements ICellRendererAngularComp {
    @ViewChild('tooltip') tooltipEl : MatTooltip;
    clicked : number = 0;
    examinations : string[] = [];
    loading : boolean = false;
    rowData : any;
    private associatedSpecialtyIconClick : any;
    constructor (
        private searchPageService : SearchPageService,
        private notificationService: NotificationService,
        private translate : TranslateService) {
    }

    agInit (params : ICellRendererParams<any, any, any>) : void {
        this.updateParams(params);
    }

    refresh (params : ICellRendererParams<any, any, any>) : boolean {
        this.updateParams(params);
        return true;
    }

    onIconClick (event: MouseEvent) {
        event.stopPropagation(); 
        this.associatedSpecialtyIconClick(event, this.rowData);
        if (this.rowData.idReport !== null && this.clicked === 0) {
            this.loading = true;

            window.alert("Chiamare il server");

            // Chiamata vuova (DA FARE)
            this.searchPageService.getAssociatedVisits(this.rowData.idReport).subscribe({
                next: (el) => {
                    this.clicked++;
                    this.generateTooltip(el);
                    this.tooltipEl.show();
                },
                error: (error) => {
                    error && error.message ?
                        this.notificationService.error(error.message) : this.notificationService.error(this.translate.instant('Exception_GenericFault'));
                    throw new Error(error);
                },
                complete: () => {
                    setTimeout(() => {
                        this.loading = false;
                    }, 1000);
                }
            });
        }
    }

    private updateParams (params : ICellRendererParams<any, any, any>) {
        this.rowData = params.data;
        this.associatedSpecialtyIconClick = params.context.associatedIconClick;
    }

    private generateTooltip (data : any) {
        data.forEach((el: any) => {
            if (el.id !== this.rowData.id) {
                this.examinations.push('\n' + el.exam.description + ': ' + this.reverseDate(el.examinationDate + ' \r\n '));
            }
        });
        this.tooltipEl.message = this.examinations.toString().replace(",", " ");
    }

    private reverseDate (isoDate : string): string {
        return isoDate.match(/([^T]+)/)[0].split("-").reverse().join("/");
    }


}
